import {
  EXPORT_SCORING_RESULTS_REPORT_CSV,
  CLEAR_EXPORT_SCORING_RESULTS_REPORT_CSV
} from '../../types';

import { createAction } from 'redux-actions';
import createAsyncActions from '../../../../utilities/createAsyncActions';

export const {
  exportScoringResultsReportCsv,
  exportScoringResultsReportCsvPending,
  exportScoringResultsReportCsvFulfilled,
  exportScoringResultsReportCsvRejected,
} = createAsyncActions(EXPORT_SCORING_RESULTS_REPORT_CSV, 'exportScoringResultsReportCsv');

export const clearScoringResultsReportCsv = createAction(CLEAR_EXPORT_SCORING_RESULTS_REPORT_CSV);



// WEBPACK FOOTER //
// ./src/features/reports/actions/scoring-results/exportScoringResultsReportCsvActions.js